// extracted by mini-css-extract-plugin
export default {"wrapper":"drawer_wrapper__HnZ9t","title":"drawer_title__SNr8r","bundleWrapper":"drawer_bundleWrapper__XtjpR","detail":"drawer_detail__cy2q5"};